(function () {
  var swiperInitialized = false;

  /* a11y: Swiper accessibility config is built from data attributes
     so all strings come from Shopify locale files (see dtc-mentions.liquid) */

  function initSwiper() {
    if (swiperInitialized) return;

    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/swiper@12.1/swiper-bundle.min.css";
    document.head.appendChild(link);

    var script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@12.1/swiper-bundle.min.js";
    script.onload = function () {
      const $currentSwiper = document.querySelector(".mySwiper");
      if (!$currentSwiper) return;

      const enableSwiperDesktop =
        $currentSwiper.dataset.enableSwiperDesktop === "true";
      const enableSwiperMobile =
        $currentSwiper.dataset.enableSwiperMobile === "true";
      const totalSlides =
        $currentSwiper.querySelectorAll(".swiper-slide").length;
      const desktopRotationSpeed =
        parseInt($currentSwiper.dataset.desktopRotationSpeed) || 5000;
      const mobileRotationSpeed =
        parseInt($currentSwiper.dataset.mobileRotationSpeed) || 5000;
      const transitionSmoothness =
        parseInt($currentSwiper.dataset.transitionSmoothness) || 750;

      /* a11y: build config from localized data attributes */
      var a11yConfig = {
        enabled: true,
        prevSlideMessage: $currentSwiper.dataset.a11yPrev || 'Previous slide',
        nextSlideMessage: $currentSwiper.dataset.a11yNext || 'Next slide',
        firstSlideMessage: $currentSwiper.dataset.a11yFirst || 'This is the first slide',
        lastSlideMessage: $currentSwiper.dataset.a11yLast || 'This is the last slide',
        paginationBulletMessage: ($currentSwiper.dataset.a11yBullet || 'Go to slide [index]').replace('[index]', '{{index}}'),
        slideLabelMessage: ($currentSwiper.dataset.a11ySlideLabel || '[index] of [total]').replace('[index]', '{{index}}').replace('[total]', '{{slidesLength}}'),
        containerRoleDescriptionMessage: 'carousel',
        itemRoleDescriptionMessage: 'slide',
      };

      /* a11y: after nav button or pagination click, move focus to the active slide.
         Per WAI carousel pattern this announces the new content immediately. */
      function bindNavFocus() {
        var nextBtn = document.querySelector('.mentions-next');
        var prevBtn = document.querySelector('.mentions-prev');
        function focusActiveSlide() {
          setTimeout(function () {
            var active = $currentSwiper.querySelector('.swiper-slide-active');
            if (active) {
              active.setAttribute('tabindex', '-1');
              active.focus();
            }
          }, 50);
        }
        if (nextBtn) nextBtn.addEventListener('click', focusActiveSlide);
        if (prevBtn) prevBtn.addEventListener('click', focusActiveSlide);
        var bullets = document.querySelectorAll('.mentions-pagination .swiper-pagination-bullet');
        bullets.forEach(function (b) { b.addEventListener('click', focusActiveSlide); });
      }

      /* a11y: pause autoplay when any element inside the carousel receives
         focus or is hovered — required by WCAG 2.2.2 (Pause, Stop, Hide) */
      function bindAutoplayPause(swiperInstance) {
        var container = $currentSwiper.closest('.slider-home');
        if (!container || !swiperInstance.autoplay) return;

        container.addEventListener('mouseenter', function () {
          swiperInstance.autoplay.stop();
        });
        container.addEventListener('mouseleave', function () {
          swiperInstance.autoplay.start();
        });
        container.addEventListener('focusin', function () {
          swiperInstance.autoplay.stop();
        });
        container.addEventListener('focusout', function (e) {
          if (!container.contains(e.relatedTarget)) {
            swiperInstance.autoplay.start();
          }
        });
      }

      function initSlider(
        event,
        enableSwiperDesktop,
        enableSwiperMobile,
        totalSlides
      ) {
        if (event.matches && enableSwiperDesktop) {
          if (window.swiperFull) {
            window.swiperFull.destroy();
          }

          window.swiperFull = new Swiper(".mySwiper", {
            slidesPerView: "auto",
            spaceBetween: 20,
            loop: totalSlides > 5,
            loopAdditionalSlides: 5,
            speed:
              totalSlides > 5 ? desktopRotationSpeed : transitionSmoothness,
            autoplay: totalSlides > 5 ? { delay: 0 } : false,
            allowTouchMove: false,
            a11y: a11yConfig,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            on: {
              slideChange: function () {
                document.querySelectorAll(".mentions-pagination .swiper-pagination-bullet").forEach(function (bullet) {
                  bullet.removeAttribute("aria-current");
                });
              },
            },
          });

          bindAutoplayPause(window.swiperFull);
          bindNavFocus();
        } else if (enableSwiperMobile) {
          if (window.swiperMobile) {
            window.swiperMobile.destroy();
          }

          let autoplayTimeout;

          window.swiperMobile = new Swiper(".mySwiper", {
            slidesPerView: 1.3,
            spaceBetween: 15,
            loop: true,
            speed: mobileRotationSpeed,
            autoplay:
              totalSlides > 1
                ? {
                    delay: mobileRotationSpeed,
                    disableOnInteraction: false,
                  }
                : false,
            allowTouchMove: true,
            a11y: a11yConfig,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            on: {
              slideChange: function () {
                document.querySelectorAll(".mentions-pagination .swiper-pagination-bullet").forEach(function (bullet) {
                  bullet.removeAttribute("aria-current");
                });
              },
              touchStart: function (swiper) {
                swiper.autoplay.stop();
                clearTimeout(autoplayTimeout);
              },
              touchEnd: function (swiper) {
                autoplayTimeout = setTimeout(() => {
                  swiper.autoplay.start();
                }, 3000);
              },
            },
          });

          bindAutoplayPause(window.swiperMobile);
          bindNavFocus();
        }
      }

      const mmObj = window.matchMedia("(min-width: 768px)");
      initSlider(mmObj, enableSwiperDesktop, enableSwiperMobile, totalSlides);
      mmObj.addEventListener("change", function () {
        initSlider(mmObj, enableSwiperDesktop, enableSwiperMobile, totalSlides);
      });
    };

    document.body.appendChild(script);
    swiperInitialized = true;
  }
  initSwiper();
})();
